'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

module.exports = function AnimationFrameComponent(InnerComponent, throttleMs) {
    return function (_React$Component) {
        _inherits(AnimatedComponent, _React$Component);

        function AnimatedComponent() {
            _classCallCheck(this, AnimatedComponent);

            var _this = _possibleConstructorReturn(this, (AnimatedComponent.__proto__ || Object.getPrototypeOf(AnimatedComponent)).call(this));

            _this.loop = _this.loop.bind(_this);
            _this.endAnimation = _this.endAnimation.bind(_this);
            _this.startAnimation = _this.startAnimation.bind(_this);

            _this.isActive = true;
            _this.rafId = 0;
            _this.lastInvocationMs = 0;
            return _this;
        }

        _createClass(AnimatedComponent, [{
            key: 'loop',
            value: function loop(time) {
                var lastInvocationMs = this.lastInvocationMs,
                    isActive = this.isActive;

                var isAnimatable = !!(this.innerComponent && this.innerComponent.onAnimationFrame);

                // Latter const is defensive check for React Native unmount (issues/#3)
                if (!isActive || !isAnimatable) return;

                var hasTimeElapsed = !throttleMs || time - lastInvocationMs >= throttleMs;

                if (hasTimeElapsed) {
                    this.lastInvocationMs = time;
                    this.innerComponent.onAnimationFrame(time, lastInvocationMs);
                }

                this.rafId = requestAnimationFrame(this.loop);
            }
        }, {
            key: 'endAnimation',
            value: function endAnimation() {
                cancelAnimationFrame(this.rafId);

                this.isActive = false;
            }
        }, {
            key: 'startAnimation',
            value: function startAnimation() {
                if (!this.isActive) {
                    this.isActive = true;
                    this.rafId = requestAnimationFrame(this.loop);
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!this.innerComponent.onAnimationFrame) {
                    throw new Error('The component passed to AnimationFrameComponent does not implement onAnimationFrame');
                }

                this.rafId = requestAnimationFrame(this.loop);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.endAnimation();
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                return React.createElement(InnerComponent, _extends({ ref: function ref(node) {
                        return _this2.innerComponent = node;
                    },
                    endAnimation: this.endAnimation,
                    startAnimation: this.startAnimation
                }, this.props));
            }
        }]);

        return AnimatedComponent;
    }(React.Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-animation-frame/dist/AnimationFrameComponent.js
// module id = 795
// module chunks = 35783957827783